import { spawn } from 'redux-saga/effects';

import ruleset from './ruleset/rulesetSagas';

export default function* sagas() {
	yield spawn(ruleset);
}
